import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconClockHistory';
/** Renders an SVG icon. */
const SvgClockHistory = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M12.99 28.686a1 1 0 0 1 1.143-.832 12 12 0 0 0 3.105.082 1 1 0 0 1 .207 1.99 14 14 0 0 1-3.623-.097 1 1 0 0 1-.832-1.143m11.582-4.287a1 1 0 1 1 1.427 1.4 14 14 0 0 1-2.85 2.237 1 1 0 1 1-1.02-1.718 12 12 0 0 0 2.442-1.92Zm-18.986-.555a1 1 0 0 1 1.411.089 12 12 0 0 0 2.338 2.046 1 1 0 1 1-1.111 1.663 14 14 0 0 1-2.728-2.387 1 1 0 0 1 .09-1.41Zm22.144-5.31a1 1 0 0 1 1.955.423 14 14 0 0 1-.498 1.746 1 1 0 0 1-1.884-.671q.26-.732.427-1.497ZM3.007 17.083a1 1 0 0 1 1.147.828q.125.775.346 1.518A1 1 0 0 1 2.583 20a14 14 0 0 1-.404-1.77 1 1 0 0 1 .828-1.147"
      />
      <path
        fill="currentColor"
        d="M14.121 2.127A14 14 0 0 1 28.73 10.17a14 14 0 0 1-3.45 16.314 1 1 0 0 1-1.326-1.498A11.999 11.999 0 1 0 5.998 9.368a1 1 0 0 1-1.666-1.105 14 14 0 0 1 9.788-6.136Z"
      />
      <path
        fill="currentColor"
        d="M14.875 7a1.125 1.125 0 0 1 2.25 0v7.875H21a1.125 1.125 0 1 1 0 2.25h-5A1.125 1.125 0 0 1 14.875 16zM4 4a1 1 0 1 1 2 0v4h4a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1z"
      />
    </svg>
  );
};
SvgClockHistory.displayName = displayName;
export default SvgClockHistory;
